import { ArrowRightLeft } from 'lucide-react';
import { useState } from 'react';
import { Button } from 'antd';
import { useHandoverTrip } from '../hooks/use-handover-trip';
import { HandoverHistory } from './HandoverHistory';
import { HandoverModal } from './HandoverModal';

interface HandoverPanelProps {
  tripId: string;
  currentDriverName: string | null;
  /** Whether the trip is in a state the office can change driver on, and the user may. */
  canHandOver: boolean;
  onHandedOver: () => void;
}

/** Who has driven a trip that has left, and the action to change driver while it is under way (gitaumoses4/chukua#80). */
export function HandoverPanel({ tripId, currentDriverName, canHandOver, onHandedOver }: HandoverPanelProps) {
  const { state, handOver, isSubmitting, error, clearError } = useHandoverTrip(tripId, onHandedOver);
  const [isOpen, setIsOpen] = useState(false);

  async function submit(values: { newDriverId: string; reason: string }): Promise<boolean> {
    const done = await handOver(values);
    if (done) setIsOpen(false);
    return done;
  }
  function close() {
    clearError();
    setIsOpen(false);
  }

  if (!canHandOver && state.status === 'loaded' && state.handovers.length === 0) return null;
  return (
    <section aria-label="Driver handover" className="rounded-lg border border-line bg-surface p-5">
      <div className="mb-3 flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 text-base font-semibold text-fg">
          <ArrowRightLeft className="size-5 text-muted" aria-hidden /> Driver handover
        </h2>
        {canHandOver && <Button onClick={() => setIsOpen(true)}>Hand over trip</Button>}
      </div>
      <HandoverHistory state={state} />
      <HandoverModal open={isOpen} currentDriverName={currentDriverName} submitting={isSubmitting} error={error} onSubmit={submit} onCancel={close} />
    </section>
  );
}
